import React from 'react';
import ReactDOM from 'react-dom';
import WebRootComponent from '/home/jenkins/workspace/owdicity-org_crowdicity-one_v1.0/packages/text-input';

// Functional tests must pass the test filename to the web page so the Apollo Client can send to the
// comp services so that the comp service knows where to load and save fixtures.
// We use the hash instead of the querystring so we don't alter the url for creating classic url.
const hashParams = new URLSearchParams(window.location.hash.substr(1));
const testFilename = hashParams.get('testFilename');
if (testFilename) {
    // Store it in case the page reloads during a test.
    localStorage.setItem('testFilename', testFilename);
}

// We check localstorage because the page could have been reloaded without the hash.
// We use testFilename because we want animations when user is using yarn start.
if (localStorage.getItem('testFilename')) {
    // Disable animations!
    const head = document.querySelector('head');
    if (head) {
        const styleTag = document.createElement('style');
        styleTag.type = 'text/css';
        styleTag.innerHTML = '* { transition: none !important; animation: none !important; }';
        head.appendChild(styleTag);
    }
}

const ReactRoot = document.querySelector('#ReactRoot');

if (WebRootComponent && ReactRoot) {
    ReactDOM.render(<WebRootComponent/>, ReactRoot);
    // Swap the above line with the following to enable strict mode.
    // ReactDOM.render(<React.StrictMode><WebRootComponent/></React.StrictMode>, ReactRoot);
}

if (module.hot) {
    // The path was required because module.hot.accept() alone wouldn't trigger the update.
    // It seemed to be because it didn't realize this bootstrapper was the entry to everything else.
    module.hot.accept('/home/jenkins/workspace/owdicity-org_crowdicity-one_v1.0/packages/text-input', () => {
        const { default: Component } = require('/home/jenkins/workspace/owdicity-org_crowdicity-one_v1.0/packages/text-input');
        ReactDOM.render(<Component/>, document.querySelector('#ReactRoot'));
    });
}